import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import Icon from '../../../Icon';
import { VITALS_ACTIVITY_TYPE } from '../../constants';
import { useActivityCardData } from './useActivityCardData';
import { EMPTY_VITALS_CARD } from './cards';
import styles from '../index.styl';

export const ActivityCard = ({
  formatMessage,
  typeCard,
  isActiveCard,
  detailsMode,
  data,
  handleOnClick,
  isWeightInKg,
  isHeightInMeters,
  mainUser,
  targetUserFirstName,
  isTemperatureInCelsius,
  isMilligramsPerDeciliter,
}) => {
  const {
    cardSource,
    cardMetric,
    cardValue,
    cardTitle,
    cardIcon,
    timeText,
  } = useActivityCardData({
    formatMessage,
    typeCard,
    data,
    isActiveCard,
    detailsMode,
    isWeightInKg,
    isHeightInMeters,
    isTemperatureInCelsius,
    isMilligramsPerDeciliter,
    mainUser,
    targetUserFirstName,
  });

  const isHeightType = VITALS_ACTIVITY_TYPE.HEIGHT === typeCard;
  const emptyCard = [EMPTY_VITALS_CARD].includes(typeCard);

  return (
    <div
      className={cn(styles.card, {
        [styles.nonClickable]: (isHeightType && !mainUser) || emptyCard,
      })}
      onClick={() => handleOnClick()}
    >
      <div className={styles.wrapperBorder}>
        <div className={styles.wrapperHover}>
          <div className={styles.cardTopWrapper}>
            <div className={styles.cardIcon}>
              <Icon name={cardIcon} size={24} />
            </div>
            <div className={styles.cardTitle}>{cardTitle}</div>
          </div>
          <div className={styles.cardBottomWrapper}>
            <div className={styles.cardValue}>
              {`${cardValue} `}
              <span className={styles.cardMetric}>{cardMetric}</span>
            </div>
            <div className={styles.cardTime}>{`${timeText}${
              cardSource ? `, ${cardSource}` : ''
            }`}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

ActivityCard.propTypes = {
  formatMessage: PropTypes.func,
  typeCard: PropTypes.string,
  isActiveCard: PropTypes.bool,
  detailsMode: PropTypes.bool,
  handleOnClick: PropTypes.func,
  data: PropTypes.object,
  isWeightInKg: PropTypes.bool,
  isHeightInMeters: PropTypes.bool,
  isTemperatureInCelsius: PropTypes.bool,
  isMilligramsPerDeciliter: PropTypes.bool,
  mainUser: PropTypes.bool,
  targetUserFirstName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/VitalsActivity/ActivityCard/index.jsx